import { render, staticRenderFns } from "./AcessoPermissaoList.vue?vue&type=template&id=b515b522&scoped=true"
import script from "./AcessoPermissaoList.vue?vue&type=script&lang=js"
export * from "./AcessoPermissaoList.vue?vue&type=script&lang=js"
import style0 from "./AcessoPermissaoList.vue?vue&type=style&index=0&id=b515b522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b515b522",
  null
  
)

export default component.exports